// App.js â€” Dark Pattern Review Tool
// Token-based auth guard using JWT in localStorage.
// Routes: /login | /sessions | /session/:id

import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { getToken, getUser } from "./api";

import LoginPage from "./components/LoginPage";
import SessionsPage from "./components/SessionsPage";
import SessionViewer from "./components/SessionViewer";
import ResetPassword from "./components/ResetPassword";
import YtScansPage from "./components/YtScansPage";
import YtScanViewer from "./components/YtScanViewer";

// ── Auth guard ────────────────────────────────────────────────────────────────
// Checks for a JWT token in localStorage. If absent, redirects to /login.
const PrivateRoute = ({ children }) => {
  return getToken() ? children : <Navigate to="/login" replace />;
};

// ── App ───────────────────────────────────────────────────────────────────────
const App = () => {
  const [isAuth, setIsAuth] = useState(!!getToken());

  // Keep isAuth in sync when localStorage changes (e.g. logout in another tab)
  useEffect(() => {
    const check = () => setIsAuth(!!getToken());
    window.addEventListener("storage", check);
    return () => window.removeEventListener("storage", check);
  }, []);

  const user = getUser();

  return (
    <BrowserRouter>
      <Routes>
        {/* Public */}
        <Route path="/login" element={
          isAuth
            ? <Navigate to="/sessions" replace />
            : <LoginPage onLogin={() => setIsAuth(true)} />
        } />

        {/* Protected */}
        <Route path="/sessions" element={
          <PrivateRoute><SessionsPage user={user} onLogout={() => setIsAuth(false)} /></PrivateRoute>
        } />
        <Route path="/session/:sessionId" element={
          <PrivateRoute><SessionViewer user={user} onLogout={() => setIsAuth(false)} /></PrivateRoute>
        } />
        <Route path="/reset-password" element={
          <PrivateRoute><ResetPassword user={user} onLogout={() => setIsAuth(false)} /></PrivateRoute>
        } />

        {/* YT Videos (admin only) */}
        <Route path="/videos" element={
          <PrivateRoute><YtScansPage user={user} onLogout={() => setIsAuth(false)} /></PrivateRoute>
        } />
        <Route path="/yt-scan/:scanId" element={
          <PrivateRoute><YtScanViewer user={user} onLogout={() => setIsAuth(false)} /></PrivateRoute>
        } />

        {/* Default */}
        <Route path="*" element={<Navigate to="/sessions" replace />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
